<tr class="total two-columns-group-sticky">
  <td class="col-first-level"></td>
  <td class="col-second-level" colspan="3">Total capital required</td>
  <td class="blank-space col-fifth-level"></td>
  @for (data of budgetFormValue$$().modelData.totalCapRequired.values; track data) {
    <td
      [attr.data-qa]="'bm-total-cap-req-'+ data.period.quarterNumber + '-' + data.period.yearNumber"
      class="bold600"
      [class.bg-black-3]="data.period.type === BmPeriodEnum.YEAR && !(budgetFormValue$$().isAllQuartersCollapsed && collapsedYears().get(data.period.yearNumber))"
      [hidden]="data.period.type === BmPeriodEnum.QUARTER  && collapsedYears().get(data.period.yearNumber)">
      {{data.itemValue | switcherDashBraces : 1 : 0}}
    </td>
    @if (data.period.type === BmPeriodEnum.YEAR && !$last) {
      <td
        [hidden]="budgetFormValue$$().isAllQuartersCollapsed && collapsedYears().get(data.period.yearNumber)"
        class="blank-space">
      </td>
    }
  }
  <td [class.bg-black-3]="!budgetFormValue$$().isAllQuartersCollapsed"></td>
  <td class="blank-space right-sticky right-[11rem]"></td>
  <td
    [attr.data-qa]="'bm-total-cap-req-row'"
    class="right-sticky right-[5.5rem] bold600">
    {{ budgetFormValue$$().modelData.totalCapRequired.totalRow | switcherDashBraces : 1 : 0}}
  </td>
  <td
    [attr.data-qa]="'bm-total-cap-req-row-pcnt'"
    class="right-sticky right-0">
    {{budgetFormValue$$().modelData.totalCapRequired.totalRowPcnt | switcherDashBraces : 1 : 1: false : '' : '%' }}
  </td>
</tr>
<tr class="total two-columns-group-sticky">
  <td class="col-first-level"></td>
  <td class="col-second-level" colspan="3">Total capital required, %</td>
  <td class="blank-space col-fifth-level"></td>
  @for (data of budgetFormValue$$().modelData.totalCapRequired.pcnt; track data) {
    <td
      [attr.data-qa]="'bm-total-cap-req-pcnt-'+ data.period.quarterNumber + '-' + data.period.yearNumber"
      class="bold600"
      [class.bg-black-3]="data.period.type === BmPeriodEnum.YEAR && !(budgetFormValue$$().isAllQuartersCollapsed && collapsedYears().get(data.period.yearNumber))"
      [hidden]="data.period.type === BmPeriodEnum.QUARTER  && collapsedYears().get(data.period.yearNumber)">
      {{data.itemValue | switcherDashBraces : 1 : 1: false : '' : '%' }}
    </td>
    @if (data.period.type === BmPeriodEnum.YEAR && !$last) {
      <td
        [hidden]="budgetFormValue$$().isAllQuartersCollapsed && collapsedYears().get(data.period.yearNumber)"
        class="blank-space">
      </td>
    }
  }
  <td [class.bg-black-3]="!budgetFormValue$$().isAllQuartersCollapsed"></td>
  <td class="blank-space right-sticky right-[11rem]"></td>
  <td data-qa="bm-total-cap-req-pcnt-row" class="right-sticky right-[5.5rem] bold600">{{ budgetForm().controls.modelData.controls.totalCapRequired.controls.totalRowPcnt.value | switcherDashBraces : 1 : 1: false : '' : '%'}}</td>
  <td class="right-sticky right-0"></td>
</tr>
<tr class="blank-row two-columns-group-sticky">
  <td class="col-first-level"></td>
  <td class="col-second-level" colspan="3"></td>
  <td class="blank-space col-fifth-level"></td>
  @for (header of budgetFormValue$$().modelHeaders; track header; let last = $last) {
    @if (header.type === BmPeriodEnum.QUARTER) {
      <td
        [hidden]="budgetFormValue$$().isAllQuartersCollapsed || collapsedYears().get(header.yearNumber)">
      </td>
    }
    @if (header.type === BmPeriodEnum.YEAR && !last) {
      <td
        [hidden]="budgetFormValue$$().isAllQuartersCollapsed || collapsedYears().get(header.yearNumber)"
        class="blank-space">
      </td>
    }
  }
  <td></td>
  <td class="blank-space right-sticky right-[11rem]"></td>
  <td class="right-sticky right-[5.5rem]"></td>
  <td class="right-sticky right-0"></td>
</tr>
<tr class="total two-columns-group-sticky">
  <td class="col-first-level"></td>
  <td class="col-second-level" colspan="3">Accumulated capital required</td>
  <td class="blank-space col-fifth-level"></td>
  @for (data of budgetFormValue$$().modelData.totalCapAccumulated.values; track data) {
    <td
      [attr.data-qa]="'bm-total-acc-req-'+ data.period.quarterNumber + '-' + data.period.yearNumber"
      class="bold600"
      [class.bg-black-3]="data.period.type === BmPeriodEnum.YEAR && !(budgetFormValue$$().isAllQuartersCollapsed && collapsedYears().get(data.period.yearNumber))"
      [hidden]="data.period.type === BmPeriodEnum.QUARTER  && collapsedYears().get(data.period.yearNumber)">
      {{data.itemValue | switcherDashBraces : 1 : 0}}
    </td>
    @if (data.period.type === BmPeriodEnum.YEAR && !$last) {
      <td
        [hidden]="budgetFormValue$$().isAllQuartersCollapsed && collapsedYears().get(data.period.yearNumber)"
        class="blank-space">
      </td>
    }
  }
  <td [class.bg-black-3]="!budgetFormValue$$().isAllQuartersCollapsed"></td>
  <td class="blank-space right-sticky right-[11rem]"></td>
  <td data-qa="bm-total-acc-req-row" class="right-sticky right-[5.5rem] bold600">{{ budgetFormValue$$().modelData.totalCapRequired.totalRow | switcherDashBraces : 1 : 0}}</td>
  <td class="right-sticky right-0 bold600"></td>
</tr>
<tr class="total two-columns-group-sticky">
  <td class="col-first-level"></td>
  <td class="col-second-level" colspan="3">Accumulated capital required, %</td>
  <td class="blank-space col-fifth-level"></td>
  @for (data of budgetFormValue$$().modelData.totalCapAccumulated.pcnt; track data) {
    <td
      [attr.data-qa]="'bm-total-acc-req-pcnt-'+ data.period.quarterNumber + '-' + data.period.yearNumber"
      class="bold600"
      [class.bg-black-3]="data.period.type === BmPeriodEnum.YEAR && !(budgetFormValue$$().isAllQuartersCollapsed && collapsedYears().get(data.period.yearNumber))"
      [hidden]="data.period.type === BmPeriodEnum.QUARTER  && collapsedYears().get(data.period.yearNumber)">
      {{data.itemValue | switcherDashBraces : 1 : 1: false : '' : '%'}}
    </td>
    @if (data.period.type === BmPeriodEnum.YEAR && !$last) {
      <td
        [hidden]="budgetFormValue$$().isAllQuartersCollapsed && collapsedYears().get(data.period.yearNumber)"
        class="blank-space">
      </td>
    }
  }
  <td [class.bg-black-3]="!budgetFormValue$$().isAllQuartersCollapsed"></td>
  <td class="blank-space right-sticky right-[11rem]"></td>
  <td data-qa="bm-total-acc-req-row" class="right-sticky right-[5.5rem]">{{ budgetFormValue$$().modelData.totalCapRequired.totalRowPcnt | switcherDashBraces : 1 : 1: false : '' : '%'}}</td>
  <td class="right-sticky right-0"></td>
</tr>
